// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"3959":"6d2ea7e0024c78848a50","9064":"33c3b89a6c1e58ca4801"}[chunkId] + ".css";
};